define('Location.VenueDetails.View.Extension', [
  'Location.VenueDetails.View',
  'underscore',
  'Profile.Model',
  'Ames.HomeStore.HomeStore.SS2Model',
  'Environment',
], function defineAddressDetailsView(
  LocationVenueDetailsView,
  _,
  ProfileModel,
  HomeStoreModel,
  Environment
) {
  'use strict';
  _.extend(LocationVenueDetailsView.prototype, {
    initialize: _.wrap(LocationVenueDetailsView.prototype.initialize, function (fn) {
      fn.apply(this, _.toArray(arguments).slice(1));
      this.homeStoreModel = new HomeStoreModel();
      this.closeMsg = '';
      var self = this;
      this.homeStoreModel.fetch({
        data: {
          locationId: this.model.get('internalid')
        }
      }).done(function(resp) {
        self.isRentalTools = resp.isRentalTools;
        if (resp.closedMsg) {
          self.closeMsg = resp.closedMsg;
        }
        self.render();
      });
    }),
    getContext: _.wrap(LocationVenueDetailsView.prototype.getContext, function (fn) {
      var context = fn.apply(this, _.toArray(arguments).slice(1));
      // debugger
      context.location.set('storeMsg', this.closeMsg);
      return context;
    }),
  });
});
